
import Text from '../ui/Text'
import checkIcon from '../../../assets/image/faq/check.png'
import chevron from '../../../assets/image/faq/chevron.png'

type Props = {
  title: string
  bullets: string[]
  open: boolean
  onToggle: () => void
}

function FAQItem({ title, bullets, open, onToggle }: Props) {
  return (
    <div className="border-b border-blue">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-4 py-3 text-left transition-colors hover:opacity-90"
        aria-expanded={open}
      >
          <div className="flex items-center gap-4">
          <img src={checkIcon} alt="Check" className="h-6 w-6 md:h-8 md:w-8 md:ml-5" />
          <Text bold text={title} size="large" />
          </div>
        <img src={chevron} alt="Chevron" className="h-3 md:h-4 mr-5 md:mr-10" />
      </button>
      <div
        className={`grid transition-[grid-template-rows] duration-200 ease-out ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
      >
        <div className="overflow-hidden">
          <ul className="list-none space-y-1 pb-5 pl-[52px] pr-4 text-blue/90">
            {bullets.map((bullet, i) => (
              <li key={i} className="md:text-lg">{i === 0 ? '' : '− '}{bullet}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default FAQItem
